import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const boomplay: MusicService = {
  id: 'boomplay',
  name: 'Boomplay',
  shortName: 'Boomplay',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: true,
  isAlbumTransferSupported: true,
  color: {
    primary: '#00FFFF',
    label: '#02D8D8',
    background: '#6e8788',
    text: '#00a6a6',
  },
  importerID: ImporterID.Boomplay,
  musicAPIID: MusicAPIIntegrationID.Boomplay,
  linkType: 'boomplay',
  limits: {
    addingTracks: 20,
  },
  assets: {
    logo: { light: 'boomplay-light.svg', dark: 'boomplay-dark.svg' },
    logoPadding: { light: 'boomplay-light-padding.svg', dark: 'boomplay-dark-padding.svg' },
    logoColor: { light: 'boomplay-color-light.svg', dark: 'boomplay-color-dark.svg' },
    logoColorPadding: {
      light: 'boomplay-color-light-padding.svg',
      dark: 'boomplay-color-dark-padding.svg',
    },
    logoOnBackground: 'boomplay-dark.svg',
  },
  whatIsDescription: musicServiceMessages.boomplayWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: false,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: false,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: false,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: false,
    doesSupportFetchingLibraryArtists: false,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: false,
    doesSupportRemovingArtistsFromLibrary: false,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: false,
    doesReturnUserCountry: false,
    maxLimit: 50,
  },
};
